import { For } from "solid-js";
import { t } from "../i18n";
import {
  MUSCLE_GROUPS,
  muscleGroupChipClass,
  type MuscleGroupId,
} from "../lib/muscleGroups";

interface Props {
  value: string[];
  onChange: (next: string[]) => void;
  /** Allow multi-select (default true). */
  multi?: boolean;
  /** Optional label above chips. */
  showLabel?: boolean;
}

function labelFor(id: MuscleGroupId): string {
  return t(`MG_${id.toUpperCase()}` as "MG_CHEST");
}

export default function MuscleGroupPicker(props: Props) {
  const multi = () => props.multi !== false;
  const selected = () => new Set(props.value ?? []);

  function toggle(id: MuscleGroupId) {
    const set = selected();
    if (multi()) {
      if (set.has(id)) {
        props.onChange(props.value.filter((g) => g !== id));
      } else {
        props.onChange([...props.value, id]);
      }
    } else {
      props.onChange(set.has(id) ? [] : [id]);
    }
  }

  return (
    <div class="space-y-1.5">
      {props.showLabel !== false && (
        <div class="label">{t("MUSCLE_GROUPS")}</div>
      )}
      <div class="flex flex-wrap gap-1.5">
        <For each={[...MUSCLE_GROUPS]}>
          {(id) => {
            const on = () => selected().has(id);
            return (
              <button
                type="button"
                class={muscleGroupChipClass(id, on())}
                aria-pressed={on()}
                onClick={() => toggle(id)}
              >
                {labelFor(id)}
              </button>
            );
          }}
        </For>
      </div>
    </div>
  );
}
